import { render, staticRenderFns } from "./AnalysisReport.vue?vue&type=template&id=9897abd4&scoped=true&"
import script from "./AnalysisReport.vue?vue&type=script&lang=js&"
export * from "./AnalysisReport.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisReport.vue?vue&type=style&index=0&id=9897abd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9897abd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9897abd4')) {
      api.createRecord('9897abd4', component.options)
    } else {
      api.reload('9897abd4', component.options)
    }
    module.hot.accept("./AnalysisReport.vue?vue&type=template&id=9897abd4&scoped=true&", function () {
      api.rerender('9897abd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/epidemic/AnalysisReport.vue"
export default component.exports